import React from 'react';
import Icon from '../../../components/AppIcon';

const UploadProgress = ({ totalFiles, completedFiles, failedFiles, uploadingFiles, overallProgress, estimatedTime, totalSpeed }) => {
  const formatTime = (seconds) => {
    if (!seconds || seconds === Infinity) return '--:--';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Upload Progress</h3>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          <span className="text-sm text-muted-foreground">
            {uploadingFiles > 0 ? 'Uploading...' : 'Ready'}
          </span>
        </div>
      </div>

      <div className="space-y-4">
        <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
          <div
            className="bg-primary h-full transition-all duration-300 ease-out"
            style={{ width: `${overallProgress}%` }}
          />
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="bg-muted rounded-lg p-3">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="Files" size={16} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">Total Files</span>
            </div>
            <p className="text-2xl font-bold text-foreground">{totalFiles}</p>
          </div>

          <div className="bg-success/10 rounded-lg p-3">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="CheckCircle2" size={16} className="text-success" />
              <span className="text-xs text-success">Completed</span>
            </div>
            <p className="text-2xl font-bold text-success">{completedFiles}</p>
          </div>

          <div className="bg-primary/10 rounded-lg p-3">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="Loader2" size={16} className="text-primary animate-spin" />
              <span className="text-xs text-primary">Uploading</span>
            </div>
            <p className="text-2xl font-bold text-primary">{uploadingFiles}</p>
          </div>

          <div className="bg-error/10 rounded-lg p-3">
            <div className="flex items-center gap-2 mb-1">
              <Icon name="XCircle" size={16} className="text-error" />
              <span className="text-xs text-error">Failed</span>
            </div>
            <p className="text-2xl font-bold text-error">{failedFiles}</p>
          </div>
        </div>

        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Icon name="Clock" size={16} />
            <span>Est. Time: <span className="font-mono">{formatTime(estimatedTime)}</span></span>
          </div>
          {totalSpeed && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Gauge" size={16} />
              <span className="font-mono">{totalSpeed}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadProgress;